import { Component, AfterViewInit, ViewChild, Input, ElementRef } from '@angular/core';
import { LanguageService } from '../../../../shared/services/language.service';

@Component({
  selector: 'app-ams-progress-bar',
  templateUrl: './ams-progress-bar.component.html',
  styleUrls: ['./ams-progress-bar.component.css']
})
export class AmsProgressBarComponent implements AfterViewInit {

  @ViewChild("theCanvas") canvas: ElementRef;
  private _width: number;
  private _height: number;
  private _value1: number;
  private _value2: number;
  private _valueText1: number;
  private _valueText2: number;

  @Input() set width(w: number) {
    this._width = Math.max(w, 50);
  }
  get width(): number {
    return this._width;
  }

  @Input() set height(h: number) {
    this._height = Math.max(h, 50);
  }
  get height(): number {
    return this._height;
  }

  // [value1]="value1" [valueText1]="valueText1"

  @Input() set value1(v: number) {
    this._value1 = v;
  }
  get value1(): number {
    return this._value1;
  }

  @Input() set valueText1(vt: number) {
    this._valueText1 = vt;
  }
  get valueText1(): number {
    return this._valueText1;
  }

  @Input() set value2(v: number) {
    this._value2 = v;
  }
  get value2(): number {
    return this._value2;
  }

  @Input() set valueText2(vt: number) {
    this._valueText2 = vt;
  }
  get valueText2(): number {
    return this._valueText2;
  }


  constructor(public ls: LanguageService) {
    this._width = 120;
    this._height = 90;
  }

  ngAfterViewInit() {
    try { 
      const canvas = this.canvas.nativeElement as HTMLCanvasElement;
      const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;

      const margin = 0;
      const xMin = margin, xMax = this._width - margin;
      const yMin = margin, yMax = this._height - margin;

      const value1 = this._value1, value2 = this._value2;
      const value1Color = (value1 <= 100 ? "green" : "#de2222"), value2Color = (value2 <= 100 ? "green" : "#de2222");
      const value1text = `${this._valueText1} ${value1}%`, value2text = `${this._valueText2} ${value2}%`;

      const theSpacing = 6;
      const theHeight = (((yMax - yMin) / 2.0 - theSpacing) | 0);
      const theWidth = xMax - xMin;
      const borderColor = "#808080";

      //draw the value1
      let startX = xMin, startY = yMin;
      ctx.strokeStyle = borderColor;
      ctx.beginPath();
      ctx.moveTo(startX, startY);
      ctx.lineTo(xMax, startY);
      ctx.lineTo(xMax, startY + theHeight);
      ctx.lineTo(startX, startY + theHeight);
      ctx.closePath();
      ctx.stroke();

      ctx.fillStyle = value1Color;
      ctx.fillRect(startX + 1, startY + 1, Math.min((theWidth - 2), (theWidth - 2) * value1 / 100.0), theHeight - 2);

      //let text1Length = ctx.measureText(value1text).width;
      ctx.fillStyle = "black";
      const fontSize = theHeight - 15;
      ctx.font = `bold ${fontSize}px Arial`;
      ctx.globalCompositeOperation = 'xor';
      ctx.fillText(value1text, startX + 2, startY + fontSize + 5);

      //draw the value2
      ctx.globalCompositeOperation = 'solid';
      startX = xMin, startY = yMin + theHeight + theSpacing;
      ctx.strokeStyle = borderColor;
      ctx.beginPath();
      ctx.moveTo(startX, startY);
      ctx.lineTo(xMax, startY);
      ctx.lineTo(xMax, startY + theHeight);
      ctx.lineTo(startX, startY + theHeight);
      ctx.closePath();
      ctx.stroke();

      ctx.fillStyle = value2Color;
      ctx.fillRect(startX + 1, startY + 1, Math.min((theWidth - 2), (theWidth - 2) * value2 / 100.0), theHeight - 2);

      ctx.fillStyle = "black";
      ctx.globalCompositeOperation = 'xor';
      ctx.fillText(value2text, startX + 2, startY + fontSize + 5);

    } catch (e) {
      //do nothing
    }
  }

}
